/**
 *
 * Asynchronously loads the component for PdfCanvasPage
 *
 */

import { lazyLoad } from 'utils/loadable';

export const PdfCanvasPage = lazyLoad(
  () => import('./index'),
  module => module.PdfCanvasPage,
);
